<template>
    <component
        v-if="showCard"
        :is="isMobile ? 'router-link' : 'div'"
        class="user-search-card"
        :class="{
            'user-search-card--deleted': profile.deleted_at,
            'user-search-card--draft': profile.draft,
        }"
        :to="isMobile ? getUserUrl : undefined"
    >
        <div class="left">
            <div class="left__avatar-wrapper">
              <img
                class="left__avatar"
                :src="profile.avatar"
                alt="аватар"
            >
            </div>
            <div class="left__info">
                <div class="left__info-age"> {{ getFullAge }} </div>
                <div class="left__info-city">{{ getAddress }}</div>
            </div>
        </div>
        <div class="right">
            <router-link
                :to="getUserUrl"
                class="right__name"
            >
                {{ getFullName }}
            </router-link>
            <div class="right__work-status">
                <div class="right__work-status_without-experience" v-if="isNoWorkExperience">Нет опыта работы</div>
                <div class="right__work-status_not-indicated" v-else-if="isEmptyCareer">Не указано место работы</div>
                <div class="has-experience" v-else>
                    <div class="has-experience__title">
                        Последнее место работы
                    </div>
                    <div class="has-experience__position">
                        <span
                            @click="isResponsibilities ? showResponsibilities = !showResponsibilities : ''"
                            class="has-experience__position-title"
                        >
                          {{ getCareerPosition }}
                        </span>
                        <transition name="fade">
                            <div
                                class="has-experience__position-responsibilities"
                                v-if="showResponsibilities"
                                v-html="getCareerResponsibilities"
                            />
                        </transition>
                    </div>
                    <div class="has-experience__company-name">{{ getCareerOrganization }}</div>
                    <div class="has-experience__period">{{ getCareerPeriod }}</div>
                </div>
            </div>
        </div>
        <div v-if="!isCurrentUserFavorite" class="user-search-card__favorite" @click="toFavorite"></div>
        <div v-else class="user-search-card__favorite-selected" @click="fromFavorite"></div>
        <div class="user-search-card__tags">
          <div
            v-for="tag in getUserTags"
            :key="tag.id"
            :style="{
              'border-color': `#${tag.meta.fill_color}`,
              'background-color': `#${tag.meta.fill_color}`,
              'color': `#${tag.meta.text_color}`
            }"
            class="user-search-card__tags-tag"
          >
          <div class="user-search-card__tags-dot" :style="{'background-color': `#${tag.meta.text_color}`}"></div>
            {{ tag.field_value }}
          </div>

            <div v-if="profile.deleted_at" class="user-search-card__deleted">
                Профиль удален
            </div>

            <div v-if="profile.draft" class="user-search-card__draft">
                Черновик
            </div>
        </div>

        <UserSearchCardHighlights
            class="user-search-card__highlights"
            :user="user"
        />
    </component>
</template>

<script>
import userSearchAvatar from "@/assets/images/user-search-avatar.svg";
import {parseISO, differenceInYears} from "date-fns";
import MONTH_NAMES from "@/consts/months";
import strCounter from "@/tools/str_counter";
import {mapGetters, mapActions} from "vuex";
import moment from "moment/moment";
import UserSearchCardHighlights from "@/components/user-search/UserSearchCardHighlights.vue";
export default {
    name: 'UserSearchCard',
    components: {UserSearchCardHighlights},

    props: {
        user: {
            type: Object,
            default: () => {},
        },
        tagsObjectByIdKey: {
          type: Object,
          deafult: () => {},
        },
        showFavorite: {
          type: Boolean,
        },
        isFavorite: {
          type: Boolean,
        },
        query: {
            type: String,
            default: () => "",
        },
        offset: {
            type: Number,
            default: () => 0,
        },
    },

    data() {
        return {
            showResponsibilities: false,
            profile: {},
            lastCareer: null,
            isFavoriteMark: false,
        };
    },

    computed: {
        ...mapGetters([
            'isMobile',
        ]),
        ...mapGetters('data', [
            'getRegistryItems',
        ]),
        ...mapGetters('auth', ['userId']),
        showCard() {
          if((!this.showFavorite && !this.isFavorite && this.isCurrentUserFavorite) || (this.isFavorite && !this.isCurrentUserFavorite)) {
            return false;
          } else {
            return true;
          }
        },
        getUserTags() {
          const resultTagsArray = [];
          if (this.profile.foreign_tags_id) {
            const userTagIds = JSON.parse(this.profile.foreign_tags_id);
            userTagIds.forEach((tagId) => {
              resultTagsArray.push(this.tagsObjectByIdKey[String(tagId)]);
            });
            return resultTagsArray;
          }
          return [];
        },
        defaultAvatar() {
            return userSearchAvatar;
        },
        getFullAge() {
            return this.getAge ? `${this.getAge} ${(strCounter("", "год", "года", "лет"))(this.getAge)}` : "";
        },
        getAge() {
            const dateOfBirth = this.profile.dateOfBirth;

            if (!dateOfBirth) {
                return null;
            }

            return differenceInYears(new Date(), parseISO(dateOfBirth));
        },
        getFullName() {
            return [
                this.profile.surname,
                this.profile.name,
                this.profile.patronymic,
            ].filter(v => v).join(' ') || 'Имя не указано';
        },
        getAddress() {
            if (this.profile.address) {
                return this.profile.address.value || "";
            } else {
                return "";
            }
        },
        getCareerPosition() {
            return this.lastCareer.position || "";
        },
        getCareerResponsibilities() {
            return (this.lastCareer.responsibilities || "").replace(/(\r\n|\n|\r)/g, '<br/>');
        },
        getCareerOrganization() {
            return this.lastCareer.organization || "";
        },
        getCareerPeriod() {
            const lastCareer = this.lastCareer;

            if (!lastCareer.data_start && !lastCareer.date_end) {
                return 'Период не указан';
            }

            const startDate = lastCareer.data_start ? `${this.getMonthYearFromDate(lastCareer.data_start)}` : 'Дата начала не указана';
            const endDate = lastCareer.date_end ? `${this.getMonthYearFromDate(lastCareer.date_end)}` : '';
            const isUntilNow = lastCareer.is_until_now;

            return `${startDate} - ${isUntilNow ? "по настоящее время" : endDate}`;
        },
        getUserId() {
            return this.profile.id;
        },
        isNoWorkExperience() {
            return this.profile.is_no_work_experience || false;
        },
        isCurrentUserFavorite() {
          let showFavorite = false;
          if (this.user.favorite_membership.length) {
            this.user.favorite_membership.forEach((membership) => {
              if(membership.membership_owner_id === this.userId) {
                showFavorite = true;
              }
            });
          }
          return showFavorite;
        },
        isResponsibilities() {
            return !!this.lastCareer.responsibilities;
        },
        isEmptyCareer() {
            return !this.lastCareer || (this.lastCareer && !this.lastCareer.organization && !this.lastCareer.position);
        },
        getUserUrl() {
            let query = this.query;
            const url = this.$router.resolve({ name: 'participant', params: { id: this.getUserId } }).href;

            query += `${query ? '&' : ''}offset=${this.offset}`;

            return `${url}?${query}`;
        },
    },

    watch: {
    },

    async created() {
    },

    methods: {
        ...mapActions([
            'addToFavorite',
            'deleteFromFavorite',
        ]),
        async toFavorite() {
          const isSuccess = await this.addToFavorite(this.getUserId);
          if (isSuccess) {
            this.user.favorite_membership.push({membership_owner_id: this.userId});
          }
        },
        async fromFavorite() {
          const isSuccess = await this.deleteFromFavorite(this.getUserId);
          if (isSuccess) {
            if (this.user.favorite_membership.length) {
              this.user.favorite_membership.forEach((membership, index) => {
                if(membership.membership_owner_id === this.userId) {
                  this.user.favorite_membership.splice(index, 1);
                }
              });
            } else {
              this.user.favorite_membership = [];
            }
          }
        },
        getMonthYearFromDate(date) {
            if (date) {
                const dateObject = new Date(date);
                const year = dateObject.getFullYear();
                const month = MONTH_NAMES[dateObject.getMonth()];
                return `${month} ${year}`;
            }
        },
    },
    mounted() {
        const user = this.user;
        this.profile = user && user.profile;

        const careers = user && user.career && user.career.length ? user.career : [];

        this.lastCareer = careers
            .sort((a, b) => {
                if ((a.is_until_now || b.is_until_now) && !(a.is_until_now && b.is_until_now)) {
                    return a.is_until_now ? -1 : 1;
                }

                if ((!a.date_start || !b.date_start) && !(!a.date_start && !b.date_start)) {
                    return a.date_start ? -1 : 1;
                }

                const startDiff = moment(a.date_start || new Date()).diff(b.date_start || new Date());

                if (startDiff !== 0) {
                    return startDiff > 0 ? -1 : 1;
                }

                if (!a.date_end || !b.date_end) {
                    return !a.date_end && !b.date_end ? 0 : a.date_end ? -1 : 1;
                }

                const endDiff = moment(a.date_end || new Date()).diff(b.date_end || new Date());

                return endDiff === 0 ? 0 : endDiff > 0 ? -1 : 1;
            })[0] || null
        ;
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";
@import "~@/styles/variables";

.user-search-card {
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: #FFF;
    padding: mrem(20);
    min-height: mrem(140);
    border-radius: mrem(16);
    box-shadow: 0px mrem(2) mrem(20) 0px rgba(70, 99, 171, 0.20);
    gap: mrem(16);

    @include on-desktop {
        flex-direction: row;
        flex-wrap: wrap;
        gap: rem(0);
        padding: rem(20);
        min-height: rem(140);
        border-radius: rem(16);
        box-shadow: 0px rem(2) rem(20) 0px rgba(70, 99, 171, 0.20);
    }

    &--deleted {
        .left, .right {
            opacity: 0.3;
        }
    }
    &--draft {
        background: #F8F8F8;
    }

    &__tags {
      padding-top: rem(16);
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      gap: rem(14);
      font-family: 'Montserrat';
      font-size: rem(14);
      font-style: normal;
      font-weight: 600;
      line-height: rem(22);

      &-dot {
        width: rem(6);
        height: rem(6);
        border-radius: rem(3);
      }

      &-tag {
        display: flex;
        align-items: center;
        gap: rem(8);
        padding: rem(4) rem(16) rem(4) rem(8);
        border-radius: rem(30) rem(60) rem(60) rem(30);
        border-width: rem(1);
        border-style: solid;
      }
    }

    &__favorite {
      width: mrem(24);
      height: mrem(24);
      cursor: pointer;
      background: url('~@/assets/images/user-search/favorite.svg') no-repeat center center;
      background-size: cover;

      @include on-desktop {
        width: rem(24);
        height: rem(24);
      }
    }

    &__favorite-selected {
      width: mrem(24);
      height: mrem(24);
      cursor: pointer;
      background: url('~@/assets/images/user-search/favorite-selected.svg') no-repeat center center;
      background-size: cover;

      @include on-desktop {
        width: rem(24);
        height: rem(24);
      }
    }

    &__deleted {
        color: $color-main-red;
        font-style: normal;
        font-weight: 500;
        position: absolute;
        font-size: mrem(16);
        line-height: mrem(34);
        right: mrem(20);
        bottom: mrem(20);

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(34);
            right: rem(20);
            bottom: rem(20);
        }
    }

    &__draft {
        color: $color-main-gray;
        font-style: normal;
        font-weight: 500;
        position: absolute;
        font-size: mrem(16);
        line-height: mrem(34);
        right: mrem(20);
        bottom: mrem(20);

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(34);
            right: rem(20);
            bottom: rem(20);
        }
    }

    &__highlights {
        width: 100%;
        margin-top: mrem(16);

        @include on-desktop {
            margin-top: rem(16);
        }
    }

    .left {
        display: grid;
        grid-template-columns: mrem(100) auto;
        justify-content: space-between;
        min-height: mrem(100);
        margin-right: mrem(24);
        gap: mrem(16);

        @include on-desktop {
            grid-template-columns: rem(100) auto;
            gap: rem(16);
            width: rem(291.17);
            min-height: rem(100);
            margin-right: rem(24);
        }

        &__avatar {
          position: absolute;
          object-fit: cover;
            &-wrapper {
              display: flex;
              overflow: hidden;
              align-items: center;
              position: relative;
              border-radius: 50%;
              max-width: mrem(100);
              max-height: mrem(100);

              @include on-desktop {
                  max-width: rem(100);
                  max-height: rem(100);
              }
            }
        }

        &__info {
            font-style: normal;
            font-size: mrem(16);
            padding: mrem(15) 0;

            @include on-desktop {
                width: rem(174);
                font-size: rem(16);
                padding: rem(15) 0;
            }

            &-age {
                color:#2A2626;
                font-weight: 600;
                line-height: mrem(26);

                @include on-desktop {
                    line-height: rem(26);
                }
            }

            &-city {
                color: $color-main-grey;
                font-weight: 400;
                line-height: mrem(20);

                @include on-desktop {
                    line-height: rem(20);
                }
            }
        }
    }

    .right {
        min-height: mrem(100);
        font-style: normal;

        @include on-desktop {
            width: rem(832.37);
            min-height: rem(100);
        }

        &__name {
            color: $color-main-blue;
            font-weight: 600;
            font-size: mrem(20);
            line-height: mrem(28);
            margin-bottom: mrem(6);

            @include on-desktop {
                font-size: rem(20);
                line-height: rem(28);
                margin-bottom: rem(6);
            }
        }

        &__work-status {
            font-style: normal;
            font-weight: 600;
            font-size: mrem(18);
            line-height: mrem(26);

            @include on-desktop {
                font-size: rem(18);
                line-height: rem(26);
            }

            &_without-experience {
                color: $color-main-grey;
            }

            &_not-indicated {
                color: $color-main-grey;
            }

            .has-experience {
                font-style: normal;
                font-size: mrem(16);
                line-height: mrem(26);

                @include on-desktop {
                    font-size: rem(16);
                    line-height: rem(26);
                }

                &__title {
                    color:$color-main-grey;
                    font-weight: 400;
                }

                &__position {
                    margin-bottom: 6px;

                    &-title {
                        color: $color-main-blue;
                        border-bottom: mrem(1) dashed;
                        font-weight: 600;
                        cursor: pointer;

                        @include on-desktop {
                            border-bottom: rem(1) dashed;
                        }
                    }

                    &-responsibilities {
                        color: #2A2626;
                        font-weight: 400;
                        width: mrem(340);
                        font-size: mrem(16);
                        line-height: mrem(26);

                        @include on-desktop {
                            width: rem(340);
                            font-size: rem(16);
                            line-height: rem(26);
                        }
                    }

                    &-responsibility {
                        color: #2A2626;
                        font-weight: 400;
                        display: flex;
                        align-items: flex-start;

                        &::before {
                            content: "";
                            display: block;
                            width: mrem(4);
                            height: mrem(4);
                            margin: mrem(11) mrem(13) 0px mrem(10);
                            border-radius: 50%;
                            background-color: #2A2626;

                            @include on-desktop {
                                width: rem(4);
                                height: rem(4);
                                margin: rem(11) rem(13) 0px rem(10);
                            }
                        }
                    }
                }

                &__company-name {
                    font-size: mrem(18);
                    font-weight: 600;

                    @include on-desktop {
                        font-size: rem(18);
                    }
                }

                &__period {
                    font-weight: 400;
                }
            }
        }
    }
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
